
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetServerSideProps, NextPage } from 'next';
import { useEffect } from 'react';
import useTranslation from 'next-translate/useTranslation';
import fetcher from '../lib/fetcher';
import { decodeBase64 } from '../lib/helper';
import useStore from '../store';
import { BiographiesExtendedResponse, FilterFacets, FilterFacetsResponse, FilterObject, SortBy, SortOrder } from '../types/api';
import Search from '../features/Search';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
type InitialFilterOptions = {
    filter?: Partial<FilterObject>;
    sortBy: SortBy;
    sortOrder: SortOrder;
};
type SearchPageProps = {
    facets: FilterFacets;
    biographies: BiographiesExtendedResponse;
} & InitialFilterOptions;
const SearchPage: NextPage<SearchPageProps> = ({ facets, biographies, filter: initialFilter, sortBy, sortOrder }) => {
    const { t } = useTranslation('common');
    const updateInitialState = useStore(state => state.search.updateInitialState);
    const updateSelected = useStore(state => state.general.updateSelected);
    const filter = useStore(state => state.search.filter);
    useEffect(() => {
        updateInitialState({
            sortBy,
            sortOrder,
            loading: false,
            facets,
            results: biographies.results,
            next: biographies.next,
            count: biographies.count,
            filter: {
                ...filter,
                ...initialFilter
            }
        });
    }, [initialFilter, biographies, updateInitialState]);
    useEffect(() => {
        return () => updateSelected(undefined);
    }, []);
    return (<>
      <SEO canonical={`/search`} title={t('seo.search.title')} description={t('seo.search.description')}/>

      <Layout>
        <Search />
      </Layout>
    </>);
};
const getServerSideProps: GetServerSideProps = async ({ res, query, locale }) => {
    const { q, id } = query;
    let options: InitialFilterOptions = {
        sortOrder: SortOrder.ASC,
        sortBy: 'relevance',
        filter: {}
    };
    if (id) {
        return {
            redirect: {
                permanent: false,
                destination: `/biography/${id}`
            }
        };
    }
    if (typeof q === 'string') {
        try {
            const object = decodeBase64(q as string);
            options = {
                ...options,
                sortBy: object.sortBy ? object.sortBy : options.sortBy,
                sortOrder: object.sortOrder ? object.sortOrder : options.sortOrder,
                filter: {
                    query: object.filter?.query,
                    placeOfBirth: object.filter?.placeOfBirth,
                    placeOfDeath: object.filter?.placeOfDeath,
                    address: object.filter?.address,
                    deportedTo: object.filter?.deportedTo,
                    school: object.filter?.school
                }
            };
        }
        catch (error) {
            console.log('Invalid base64 query string', error);
        }
    }
    const facets = await fetcher<FilterFacetsResponse>(`/${locale}/biographies/search/filters/`, {
        method: 'POST',
        body: JSON.stringify({ filter: options.filter })
    });
    const biographies = await fetcher<BiographiesExtendedResponse>(`/${locale}/biographies/search/?limit=50`, {
        method: 'POST',
        body: JSON.stringify({
            sortBy: options.sortBy,
            sortOrder: options.sortOrder,
            returnType: 'extended',
            filter: options.filter
        })
    });
    /**
     * Otherwise return data to page
     * with cache-control header
     */
    res.setHeader('Cache-Control', 's-maxage=30, stale-while-revalidate=300');
    return {
        props: {
            facets: {
                ...facets.data,
                placeOfBirth: (facets.data.placeOfBirth || []).filter(i => i.key !== ''),
                placeOfDeath: (facets.data.placeOfDeath || []).filter(i => i.key !== ''),
                address: (facets.data.address || []).filter(i => i.key !== ''),
                deportedTo: (facets.data.deportedTo || []).filter(i => i.key !== ''),
                school: (facets.data.school || []).filter(i => i.key !== '')
            },
            biographies: biographies.data,
            filter: options.filter,
            sortOrder: options.sortOrder,
            sortBy: options.sortBy
        }
    };
};
export default SearchPage;

    async function __Next_Translate__getServerSideProps__18f80c52fd7__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/search',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__18f80c52fd7__ as getServerSideProps }
  